import {Injectable} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';

const ServiceName = 'Events Service';

export interface IEventService {
  publish(event: string, eventObject?: any);

  subscribe(event: string): Observable<any>;

  subscribe(event: string, callback: (value: any) => void, error: (error?: any) => void, complete?: () => void): Subscription;
}

@Injectable({providedIn: 'root'})
export class RxEventBusService implements IEventService {

  private events: any = {};

  constructor() {
  }

  publish(event: string, eventObject?: any) {
    if (!event) {
      throw new Error(`[${ServiceName}] => Publish method must get event name.`);
    } else if (!this.events[event]) {
      return;
    }

    this.events[event].next(eventObject);
  }

  subscribe(event: string): Observable<any>;
  subscribe(event: string, callback: (value: any) => void, error: (error: any) => void, complete: () => void): Subscription;
  subscribe(
    event: string,
    callback?: (value: any) => void, error?: (error: any) => void, complete?: () => void
  ): Observable<any> | Subscription {
    if (!event) {
      throw new Error(`[${ServiceName}] => Subscription method must get event name.`);
    }

    if (this.events[event] === undefined) {
      this.events[event] = new Subject<any>();
    }

    if (typeof callback !== 'function') {
      return this.events[event].asObservable();
    } else {
      return this.events[event].asObservable().subscribe(callback, error, complete);
    }
  }

}
